import React, { useEffect, useState } from 'react';
import GridInputs from '../../../components/common/inputs/GridInputs';
import axios from 'axios';
import { SubmitButton } from '../../../components/common/button/CustomButtons';
import useConfirm from '../../../components/common/useConfirm';
import GridDatePicker from '../../../components/common/inputs/GridDatePicker';
import AutocompleteMuiCustom from '../../../components/common/AutocompleteMuiCustom';
import { Grid, MenuItem, SelectChangeEvent } from '@mui/material';
import GridSelect from '../../../components/common/inputs/GridSelect';
import CustomUploadButton from '../../../components/common/button/CustomUploadButton';
import { Loader } from '../../../components/common/Loader';
import ModalCustom from '../../../components/common/Modal';
import { DivStyled } from '../../../assets/styles/components/DivStyledLableInputs';
import {
  AddIconButton,
  RemoveIconButton,
} from '../../../components/common/button/CustomIconButton';
import PartTable from './components/PartTable';
import { Checkbox } from '@mui/material';
import AutocompleteGridmui from '../../../components/common/autocomplete/AutocompleteGridmui';

const Create = ({
  id,
  setIsModal,
}: {
  id?: string | null;
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [data, setData] = useState<any>({
    exclude_report: false,
  });
  const [files, setFiles] = useState<any>(null);
  const [images, setImages] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [DialogSubmit, confirmSubmit] = useConfirm(
    `${id ? 'Update Vendor' : 'Create Ventor'}`,
    `Are you sure you want to ${id ? 'update' : 'save'} this?`,
  );
  const [customerData, setCustomerData] = useState([]);
  const [defectData, setDefectData] = useState([]);
  const [isPartModal, setIsPartModal] = useState(false);
  const [render, setRender] = useState(false);

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/customerConcernRoutes/${id}`)
        .then((res) => {
          setData(res?.data);
        })
        .catch((err) => console.log(err));
    }
  }, [id]);
  useEffect(() => {
    axios
      .get('/api/customerRoutes/customerList/customerForAutoComplete')
      .then((res) => {
        setCustomerData(res.data);
      })
      .catch((err) => console.log(err));

    axios
      .get('/api/defectRoutes/defectList/defectForAutoComplete')
      .then((res) => {
        setDefectData(res.data);
      })
      .catch((err) => console.log(err));
  }, []);

  function handleCustomerData(
    e: React.ChangeEvent<HTMLInputElement> | SelectChangeEvent<unknown>,
  ) {
    setData((prev: any) => ({ ...prev, [e.target.name]: e.target.value }));
  }
  const handleSumbit = async () => {
    if (!data.customer_id) {
      alert('Please enter customer name');
      return;
    }
    // if (!data.type_of_complaint) {
    //   alert('Please enter type of complaint(Domestic/Exports)');
    //   return;
    // }
    if (!data.defect_id) {
      alert('Please enter defect name');
      return;
    }

    const ans = await confirmSubmit();
    if (!ans) return;

    setIsLoading(true);
    const formData = new FormData();

    if (typeof data.customer_id === 'object') {
      data.customer_id = data.customer_id._id;
    }
    if (typeof data.defect_id === 'object') {
      data.defect_id = data.defect_id._id;
    }
    if (typeof data.part_id === 'object') {
      data.part_id = data.part_id._id;
    }
    for (const key in data) {
      if (data[key] || typeof data[key] == 'boolean') {
        if (key !== 'files' && key !== 'images') {
          formData.append(key, data[key]);
        }
      }
    }

    if (files) {
      for (const key of Object.keys(files)) {
        formData.append('files', files[key]);
      }
    }
    if (images) {
      for (const key of Object.keys(images)) {
        formData.append('images', images[key]);
      }
    }

    if (id) {
      await axios
        .put(`/api/customerConcernRoutes/${id}`, formData)
        .then((res) => {
          setIsLoading(false);
          setIsModal(false);
        })
        .catch((err) => console.log(err));
    } else {
      await axios
        .post('/api/customerConcernRoutes', formData)
        .then((res) => {
          setIsLoading(false);
          setIsModal(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log(err);
        });
    }
  };

  return (
    <>
      <Loader loader={isLoading} />
      <h1>Plan</h1>
      <GridDatePicker
        label_name="DATE OF OCCURRENCE"
        html_for={'issue_reported_date'}
        value={data?.issue_reported_date || null}
        onChange={(date) => {
          data.issue_reported_date = date;
        }}
      />
      <DivStyled style={{ alignItems: 'center' }}>
        <label>{'Part Number'}</label>
        <div
          style={{
            borderLeft: '2px solid #ced4da',
            paddingLeft: '1rem',
            width: '100%',
          }}
        >
          <Grid container xs={12} direction="row" alignItems={'center'}>
            <Grid item xs={10}>
              <p
                style={{
                  fontSize: '1.6rem',
                }}
              >
                {typeof data?.part_id === 'object' && data?.part_id !== null
                  ? data?.part_id?.part_number
                  : data?.partNumber || ''}
              </p>
            </Grid>

            {data.part_id ? (
              <Grid item xs={2}>
                <RemoveIconButton
                  tooltipTitle="remove part"
                  onClick={() => {
                    data.part_id = null;
                    data.partNumber = null;
                    data.partName = null;

                    setRender((prev) => !prev);
                  }}
                />
              </Grid>
            ) : (
              <Grid item xs={2}>
                <AddIconButton
                  tooltipTitle="add part"
                  onClick={() => {
                    setIsPartModal(true);
                  }}
                />
              </Grid>
            )}
          </Grid>
        </div>
      </DivStyled>
      <DivStyled style={{ alignItems: 'center' }}>
        <label>{'Part Name'}</label>
        <div
          style={{
            borderLeft: '2px solid #ced4da',
            paddingLeft: '1rem',
            width: '100%',
          }}
        >
          <Grid container xs={12} direction="row" alignItems={'center'}>
            <Grid item xs={10}>
              <p
                style={{
                  fontSize: '1.6rem',
                }}
              >
                {typeof data?.part_id === 'object' && data?.part_id !== null
                  ? data?.part_id?.part_name
                  : data?.partName || ''}
              </p>
            </Grid>
          </Grid>
        </div>
      </DivStyled>
      <AutocompleteGridmui
        label={'CUSTOMER'}
        id={'customer_name'}
        option_name={'customer_name'}
        value={data?.customer_id || ''}
        arrayofObj={customerData}
        onChange={(e, value) => {
          data.customer_id = value;
          setRender((prev) => !prev);
        }}
      />
      <GridInputs
        id={'defect_qty'}
        name={'defect_qty'}
        html_for={'defect_qty'}
        label_name={'DEFECT QTY. (In Nos)'}
        input_type={'number'}
        focusType={'onblur'}
        value={data?.defect_qty || ''}
        onChange={handleCustomerData}
      />
      <AutocompleteGridmui
        label={'DEFECT DETAIL'}
        id={'defect_name'}
        option_name={'defect_name'}
        value={data?.defect_id || ''}
        arrayofObj={defectData}
        onChange={(e, value) => {
          data.defect_id = value;
          setRender((prev) => !prev);
        }}
      />
      <GridInputs
        id={'root_cause'}
        name={'root_cause'}
        html_for={'root_cause'}
        label_name={'ROOT CAUSE:'}
        input_type={'text'}
        focusType={'onblur'}
        value={data?.root_cause || ''}
        onChange={handleCustomerData}
      />
      <Grid item xs={3} m={1}>
        <CustomUploadButton
          lable={'Defect photo'}
          multiple
          accept="image/png,image/jpeg,image/jpg"
          onChange={(e) => {
            if (files) {
              setFiles([...files, ...e.target.files]);
            } else {
              setFiles(e.target.files);
            }
          }}
        />{' '}
      </Grid>
      <h1>Do</h1>
      <GridInputs
        id={'action_taken'}
        name={'action_taken'}
        html_for={'action_taken'}
        label_name={'ACTION TO BE TAKEN:'}
        input_type={'text'}
        focusType={'onblur'}
        value={data?.action_taken || ''}
        onChange={handleCustomerData}
      />
      <GridDatePicker
        label_name="TARGET DATE:"
        html_for={'target_date'}
        value={data?.target_date || null}
        onChange={(date) => {
          data.target_date = date;
        }}
      />
      <GridDatePicker
        label_name="ACTUAL CLOSURE DATE"
        html_for={'actual_closure_date'}
        value={data?.actual_closure_date || null}
        onChange={(date) => {
          data.actual_closure_date = date;
        }}
      />
      <GridInputs
        id={'responsibility'}
        name={'responsibility'}
        html_for={'responsibility'}
        label_name={'RESPONSIBILITY:'}
        input_type={'text'}
        focusType={'onblur'}
        value={data?.responsibility || ''}
        onChange={handleCustomerData}
      />
      <h1>Effectiveness Monitoring</h1>
      {Array.from({ length: 10 }, (_, i) => (
        <React.Fragment key={i + 1 + 'heading'}>
          <GridDatePicker
            label_name={`${`L ${i + 1} Inovice Date:`}`}
            html_for={`${`l${i + 1}_invoice_date`}`}
            value={data?.[`${`l${i + 1}_invoice_date`}`] || null}
            onChange={(date) => {
              data[`${`l${i + 1}_invoice_date`}`] = date;
            }}
          />
          <GridInputs
            id={`l${i + 1}_invoice_no`}
            name={`l${i + 1}_invoice_no`}
            html_for={`l${i + 1}_invoice_no`}
            label_name={`L${i + 1} Inovice No.:`}
            input_type={'text'}
            focusType={'onblur'}
            value={data?.[`${`l${i + 1}_invoice_no`}`] || ''}
            onChange={handleCustomerData}
          />
          <GridInputs
            id={`l${i + 1}_dispatch_qty`}
            name={`l${i + 1}_dispatch_qty`}
            html_for={`l${i + 1}_dispatch_qty`}
            label_name={`L${i + 1} Dispatch Qty.:`}
            input_type={'number'}
            focusType={'onblur'}
            value={data?.[`${`l${i + 1}_dispatch_qty`}`] || ''}
            onChange={handleCustomerData}
          />
          <GridSelect
            name={`l${i + 1}_status`}
            label_name={`L${i + 1} Status:`}
            html_for={`l${i + 1}_status`}
            value={data?.[`${`l${i + 1}_status`}`] || ''}
            onChange={handleCustomerData}
          >
            <MenuItem value="OK">OK</MenuItem>
            <MenuItem value="NOT OK">NOT OK</MenuItem>
          </GridSelect>
        </React.Fragment>
      ))}
      <GridSelect
        name="horizontal_delotment"
        label_name="HORIZONTAL DEPLOYMENT"
        html_for={'horizontal_delotment'}
        value={data?.horizontal_delotment || ''}
        onChange={handleCustomerData}
      >
        <MenuItem value="Y">Y</MenuItem>
        <MenuItem value="N">N</MenuItem>
      </GridSelect>
      <GridInputs
        id={'lessons_learnt'}
        name={'lessons_learnt'}
        html_for={'lessons_learnt'}
        label_name={'LESSONS LEARNT:'}
        input_type={'text'}
        focusType={'onblur'}
        value={data?.lessons_learnt || ''}
        onChange={handleCustomerData}
      />
      <h1>ACT</h1>
      <GridSelect
        name="quality_alert"
        label_name="QUALITY ALERT"
        html_for={'quality_alert'}
        value={data?.quality_alert || ''}
        onChange={handleCustomerData}
      >
        <MenuItem value="Y">Y</MenuItem>
        <MenuItem value="N">N</MenuItem>
      </GridSelect>
      <GridSelect
        name="pfd"
        label_name="DRG. / PFD"
        html_for={'pfd'}
        value={data?.pfd || ''}
        onChange={handleCustomerData}
      >
        <MenuItem value="Y">Y</MenuItem>
        <MenuItem value="N">N</MenuItem>
      </GridSelect>
      <GridSelect
        name="pfmea"
        label_name="PFMEA"
        html_for={'pfmea'}
        value={data?.pfmea || ''}
        onChange={handleCustomerData}
      >
        <MenuItem value="Y">Y</MenuItem>
        <MenuItem value="N">N</MenuItem>
      </GridSelect>
      <GridSelect
        name="control_plan"
        label_name="CONTROL PLAN"
        html_for={'control_plan'}
        value={data?.control_plan || ''}
        onChange={handleCustomerData}
      >
        <MenuItem value="Y">Y</MenuItem>
        <MenuItem value="N">N</MenuItem>
      </GridSelect>
      <GridSelect
        name="inspection_std"
        label_name="INSPECTION STD."
        html_for={'inspection_std'}
        value={data?.inspection_std || ''}
        onChange={handleCustomerData}
      >
        <MenuItem value="Y">Y</MenuItem>
        <MenuItem value="N">N</MenuItem>
      </GridSelect>
      <GridSelect
        name="work_instruction"
        label_name="WORK INSTRUCTIONS"
        html_for={'work_instruction'}
        value={data?.work_instruction || ''}
        onChange={handleCustomerData}
      >
        <MenuItem value="Y">Y</MenuItem>
        <MenuItem value="N">N</MenuItem>
      </GridSelect>
      <GridSelect
        name="training"
        label_name="TRAINING"
        html_for={'training'}
        value={data?.training || ''}
        onChange={handleCustomerData}
      >
        <MenuItem value="Y">Y</MenuItem>
        <MenuItem value="N">N</MenuItem>
      </GridSelect>
      <GridSelect
        name="status"
        label_name="Status"
        html_for={'status'}
        value={data?.status || ''}
        onChange={handleCustomerData}
      >
        <MenuItem value="CLOSED">CLOSED</MenuItem>
        <MenuItem value="OPEN">OPEN</MenuItem>
        <MenuItem value="REVERSED">REVERSED</MenuItem>
        <MenuItem value="UNDER REVERSAL">UNDER REVERSAL</MenuItem>
        <MenuItem value="ACTION SUBMITTED">ACTION SUBMITTED</MenuItem>
      </GridSelect>
      <GridInputs
        id={'remarks'}
        name={'remarks'}
        html_for={'remarks'}
        label_name={'REMARKS:'}
        input_type={'text'}
        focusType={'onblur'}
        value={data?.remarks || ''}
        onChange={handleCustomerData}
      />
      <Grid item xs={3}>
        <CustomUploadButton
          lable={'Attach Supporting Doucments'}
          multiple
          accept="application/pdf,application/doc,application/excel/,application/ppt"
          onChange={(e) => {
            if (files) {
              setFiles([...files, ...e.target.files]);
            } else {
              setFiles(e.target.files);
            }
          }}
        />{' '}
      </Grid>
      <div>
        <Checkbox
          name="exclude_report"
          checked={data?.exclude_report}
          onChange={(e) => {
            setData((prev: any) => ({
              ...prev,
              [e.target.name]: e.target.checked,
            }));
          }}
        />

        <span
          style={{
            fontWeight: '500',
            fontSize: '20px',
          }}
        >
          Exclude from report
        </span>
      </div>

      <div
        className="btn_save"
        style={{
          position: 'absolute',
          right: '140px',
          top: '-0.6px',
        }}
      >
        <SubmitButton
          label={`${id ? 'update' : 'submit'}`}
          type="button"
          onClick={handleSumbit}
        />
      </div>
      <DialogSubmit />
      <ModalCustom
        openModal={isPartModal}
        closeModal={() => {
          setIsPartModal(false);
        }}
        title="PART"
      >
        <PartTable moduleData={data} />
      </ModalCustom>
    </>
  );
};

export default Create;
